<template>
  <div>
    <base-upload-files :documento-id="dataForm.documento_id" tipo='pdf' folder="/documentaciones/contratos" :maxSize="5" @documento="dataForm.documento_id = $event" />
  </div>
</template>

<script>
  // import { toastrInfo, toastrDefault } from '../toastrConfig'
  // import $ from 'jquery'

  export default {
    data: () => ({
      contrato: {},
      accept: 'image/*',
      loading: true,
      imagen: null,
      benched: 0,
      dataForm: {
        documento_id: 0,
      },
    }),
    computed: {
      items () {
        return Array.from({ length: this.length }, (k, v) => v + 1)
      },
      length () {
        return 7000
      },
    },
    created () {
      this.getImage()
      this.VerPrmisos()
    },
    methods: {
      show: function () {
        this.$http.get('/api/storage/show')
      },
      getImage: function () {
        // this.$http.get('/api/image/' + 'sXKUxmkyGnyQVUk0bLotK1QFmmbPIuLUxf31sP9F.gif')
      },
      getNewToken: function () {
        const dat = {
          refresh_token: this.$store.state.resetToken,
        }
        // console.log('REfresh Token: ')
        // console.log(dat)
        this.$http({
          method: 'post',
          url: '/api/refresh-token',
          data: {
            ...dat,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        })
      },
      VerPrmisos: function () {
        // console.log(this.$store.state.permission.permissions)
        // console.log('token: ')// eslint-disable-line no-console
        // console.log(this.$store.state.token) // eslint-disable-line no-console
        // console.log('Esta auth: ' . this.$store.state.token)
      },
    },
  }
  /*
TOP_LEFT = "top-left",
    TOP_CENTER = "top-center",
    TOP_RIGHT = "top-right",
    BOTTOM_LEFT = "bottom-left",
    BOTTOM_CENTER = "bottom-center",
    BOTTOM_RIGHT = "bottom-right"
*/
</script>

/*
await this.$http({
          method: method,
          url: '/api/scouting_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
 */
